
<div class="search_result">
  <div class="result"
    *ngFor="let landTitle of landTitles"
    (click)="onView(landTitle)"
    style="cursor: pointer;"
  >
    <h2 class="name"><em class="ti-user"></em>  {{ landTitle?.LandName }}</h2>
    <div class="other-info">
      <p class="phone"><em class="ti-mobile"></em> {{ landTitle?.AcquisitionDate | date }}</p>
      <p class="email"><em class="ti-email"></em> {{ landTitle?.SubGroupId }}</p>
      <p class="account"><em class="ti-info-alt"></em> {{landTitle?.SubSubGroupId}}</p>
      <!-- <p class="number"><em class="ti-info-alt"></em> {{landTitle?.AccountNo}}</p> -->
    </div>
  </div>


</div>
